import { useEffect } from 'react';

import useAudioPlayer from '@/shared/hooks/useAudioPlayer';
import { useResolvedGameAudioOn } from '@/shared/hooks/useGameAudioSettings';
import { usePageActive } from './usePageActive';

import musicUrl from '../assets/sounds/background-music.mp3';

export function useBackgroundMusic() {
	const audioOn = useResolvedGameAudioOn();
	const pageActive = usePageActive();
	const music = useAudioPlayer({ src: musicUrl, loop: true, volume: 0.15, html5: true });
	useEffect(() => {
		if (audioOn && pageActive) music.play();
		else music.pause();
	}, [audioOn, pageActive, music.play, music.pause]);
}
